import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../styles/ForumPage.css';
import apiClient from '../Api/apiConfig';

export default function ForumMessages() {
  const { themeId } = useParams();
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await apiClient.get(`/api/forum-posts/${themeId}/messages`); 
        if (!response.ok) {
          throw new Error(`Erreur HTTP ! Statut : ${response.status}`);
        }
        const data = await response.json();
        setMessages(data);
      } catch (error) {
        console.error('Erreur lors du chargement des messages :', error.message);
      }
    };

    fetchMessages();
  }, [themeId]);

  return (
    <div className="forum-messages">
      <h1 className="messages-title">Messages pour le thème</h1>
      {messages.length === 0 ? (
        <p>Aucun message pour ce thème.</p>
      ) : (
        messages.map((message) => (
          <div key={message.id} className="message">
            <h2 className="message-title">{message.title}</h2>
            <p className="message-content">{message.content}</p>
            <div className="message-author">Par : {message.author_name}</div>
          </div>
        ))
      )}
    </div>
  );
}
